import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UploadImagesForApprovalComponent } from './components/upload-images-for-approval/upload-images-for-approval.component';
import { PhotographerAuthGuard } from '../guards/photographer-auth.guard';
import { PageUrlsParts, PageUrls } from '../helpers/page-urls';
import { DashboardComponent } from './dashboard.component';
import { ImagesHistoryComponent } from './components/images-history/images-history.component';
import { PhotographerProfileComponent } from './components/profile/profile.component';
import { ZohoBookBillListComponent } from './components/zoho-book/list/zoho.book.bill.list.component';
import { ZohoBookDetailComponent } from './components/zoho-book/detail/zoho.book.detail.component';
import { PaymentLogComponent } from './components/payment-log/payment.log.component';


const routes: Routes = [
  { path: PageUrlsParts.Photographer.Self, component: DashboardComponent, canActivate: [PhotographerAuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: PageUrls.Photographer.UploadImages },
      { path: PageUrlsParts.Photographer.UploadImages, component: UploadImagesForApprovalComponent },
      { path: PageUrlsParts.Photographer.ImagesHistory, component: ImagesHistoryComponent },
      { path: PageUrlsParts.Photographer.Profile, component: PhotographerProfileComponent },
      { path: PageUrlsParts.Photographer.ZohoBookBill, component: ZohoBookBillListComponent },
      { path: PageUrlsParts.Photographer.ZohoBookBillDetail, component: ZohoBookDetailComponent },
      { path: PageUrlsParts.Photographer.Payment, component: PaymentLogComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PhotographerRoutingModule { }
